// TODO: refactor (too many props)
import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import Endpoints from './Accordion';
import Modal from './Modal';
import Snackbar from '../../../common/Snackbar';

export default function handler(props) {
  const { selectedServer } = props;

  // local state
  const [endpoints, setEndpoints] = useState([]);
  const [responses, setResponses] = useState({});
  const [loading, setLoading] = useState({});
  const [fetching, setFetching] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalEndpoint, setModalEndpoint] = useState(null);

  // global state
  const nodes = useSelector((state) => state.networkUndo.present.nodes);
  const edges = useSelector((state) => state.networkUndo.present.edges);

  // snackbar
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'info',
  });
  const showSnackbar = (message, severity = 'info') => {
    setSnackbar({ open: true, message, severity });
  };

  // effects
  useEffect(() => {
    async function fetchEndpoints() {
      setFetching(true);
      setEndpoints([]);
      try {
        const response = await fetch(`${selectedServer}/endpoints`);
        const data = await response.json();
        setEndpoints(data.endpoints);
      } catch (error) {
        showSnackbar(`Error fetching endpoints: ${error.message}`, 'error');
      }
      setFetching(false);
    }
    fetchEndpoints();
  }, [selectedServer]);

  // handlers
  const fetchDataForEndpoint = async (endpointPath) => {
    setLoading((prev) => ({ ...prev, [endpointPath]: true }));
    try {
      const index = endpoints.findIndex((item) => item.path === endpointPath);
      const response = await fetch(
        `${selectedServer}${endpointPath}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            graph: { nodes, edges },
            ...endpoints[index].optional_args.reduce((acc, { key, value }) => {
              acc[key] = value;
              return acc;
            }, {}),
          }),
        },
      );
      const contentType = response.headers.get('Content-Type');
      const endpointResponse = { type: contentType };
      if (contentType.includes('text/plain')) {
        endpointResponse.data = await response.text();
      } else if (contentType.includes('text/html')) {
        endpointResponse.data = await response.text();
      } else if (contentType.includes('application/json')) {
        endpointResponse.data = await response.json();
      } else if (contentType.includes('image/')) {
        const blob = await response.blob();
        endpointResponse.data = URL.createObjectURL(blob);
      }
      setResponses((prevResponses) => ({ ...prevResponses, [endpointPath]: endpointResponse }));
    } catch (error) {
      showSnackbar(`Error fetching result for ${endpointPath}: ${error.message}`, 'error');
    } finally {
      setLoading((prev) => ({ ...prev, [endpointPath]: false }));
    }
  };

  const handleOpenModal = (endpoint) => {
    setModalEndpoint(endpoint);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setModalEndpoint(null);
  };

  const setEndpointArgs = (endpoint, args) => {
    const index = endpoints.findIndex((item) => item.path === endpoint.path);
    endpoints[index].optional_args = args;
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <div>
      {fetching && <Typography sx={{ my: 2 }}>Loading...</Typography>}
      {endpoints.length === 0 && !fetching && (
        <Typography sx={{ my: 2 }}>
          Please start the API server and refresh
        </Typography>
      )}
      {endpoints.length > 0 && (
        <Endpoints
          endpoints={endpoints}
          responses={responses}
          fetchDataForEndpoint={fetchDataForEndpoint}
          setEndpointArgs={setEndpointArgs}
          loading={loading}
          handleOpenModal={handleOpenModal}
        />
      )}
      <Modal
        modalOpen={modalOpen}
        modalEndpoint={modalEndpoint}
        responses={responses}
        loading={loading}
        handleCloseModal={handleCloseModal}
        fetchDataForEndpoint={fetchDataForEndpoint}
        setEndpointArgs={setEndpointArgs}
      />
      <Snackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={handleCloseSnackbar}
      />
    </div>
  );
}
